import { render, staticRenderFns } from "./HomeCards.vue?vue&type=template&id=8858ef06&scoped=true"
import script from "./HomeCards.vue?vue&type=script&lang=js"
export * from "./HomeCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8858ef06",
  null
  
)

export default component.exports